// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavigationWrapper_wrapper__3iJzs","left":"NavigationWrapper_left__7AbYD"};